import {DeskRef, EmployeeRef, NewJoinerChecklistItemForm, NewJoinerForm} from "./Model";
import {createProjection} from "../util/ProjectionUtil";

export const toEmployeeRef: (employee: EmployeeRef) => EmployeeRef =
    createProjection(['id', 'fullName', 'deactivated'])

export const toNewJoinerChecklistItemForm: (item: NewJoinerChecklistItemForm) => NewJoinerChecklistItemForm =
    createProjection(['category', 'label', 'link', 'ordinal', 'filters'])

export const toNewJoinerForm: (newJoiner: NewJoinerForm) => NewJoinerForm =
    createProjection(['person', 'joinDate', 'type', 'remote', 'notes', 'checklist'])

export const toDeskRef: (desk: DeskRef) => DeskRef =
    createProjection(['id', 'name'])